import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { isSupabaseError } from '../../../../constants/supabaseErrors';
import { QuoteCompaisonColumnDatabase } from '../../../../types';
import { useSaveQuoteColumn } from '../../api/useSaveQuoteColumn';
import { COLUMN_TYPES } from '../../utils/columnTypes';

const formSchema = z.object({
  label: z.string().trim().min(1, 'Donnez un nom au critère'),
  type: z.enum(COLUMN_TYPES),
});

type FormValues = z.infer<typeof formSchema>;

type Props = {
  groupId: string;
  /** Position given to a new criterion. */
  nextOrder: number;
  column?: QuoteCompaisonColumnDatabase;
  onClose: () => void;
};

export function useQuoteColumnFormDialog(props: Props) {
  const { mutateAsync, isPending } = useSaveQuoteColumn();
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      label: props.column?.label ?? '',
      type: props.column?.type ?? 'text',
    },
  });

  async function handleSubmit(values: FormValues) {
    setServerError(null);

    try {
      await mutateAsync({
        groupId: props.groupId,
        columnId: props.column?.id,
        label: values.label.trim(),
        type: values.type,
        order: props.nextOrder,
      });
      props.onClose();
    } catch (error: unknown) {
      setServerError(isSupabaseError(error) ? error.message : 'Le critère n\'a pas pu être enregistré. Réessayez.');
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    form,
    isEdition: !!props.column,
    onSubmit: form.handleSubmit(handleSubmit),
    isPending,
    serverError,
    handleClose,
  };
}
